var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "color-input" },
    [
      _c("div", {
        staticClass: "color-input-output",
        style: { "background-color": _vm.colors.hex, opacity: _vm.colors.a },
        on: { click: _vm.toggleColorPicker }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.toggle
            ? _c("color-picker", {
                staticClass: "color-input-picker",
                attrs: { colors: _vm.colors },
                on: {
                  input: function(val) {
                    _vm.$emit("input", val)
                  },
                  click: function($event) {
                    $event.preventDefault()
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b014d3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b014d3f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/ColorInput.vue
// module id = 134
// module chunks = 0